/****************************************************************************************************************
* ©2019 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { Component, Input, OnInit, EventEmitter, Output, OnDestroy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { Constants } from '../../../shared.constants';
import { Subscription } from 'rxjs';
import { DynamicFormControlService } from '../../../services/dynamic-form-control.service';

@Component({
    selector: 'dynamic-form-field',
    templateUrl: './dynamic-form-field.component.html',
    styleUrls: ['./dynamic-form-field.component.scss'],
    standalone: false
})
export class DynamicFormFieldComponent implements OnInit, OnDestroy {
    @Input() field: any;
    @Input() form: UntypedFormGroup;
    @Input() readonly: boolean;
    @Output('onDropdownSelectionChange') dropdownEvent: EventEmitter<DropdownData> = new EventEmitter();
    matInputError: string;
    dynamicdropdownOptions: Subscription;

    constructor(private dynamicFormService: DynamicFormControlService) {
        this.dynamicdropdownOptions = this.dynamicFormService.dynamicDropdownOptions.subscribe((result: DropdownData) => {
            if (!result || !result.key)
                return;
            if (this.field && this.field.key === result.key) {
                console.log("dynamicdropdownOptions observable: value = ", result);
                this.field.options = result.options;
            }
        });
    }

    get isValid() { return this.field && this.form && this.form.controls[this.field.key] ? this.form.controls[this.field.key].valid : false; }

    ngOnInit() {
        if (!this.field) {
            return;
        }
        if (this.readonly && this.form) {
            this.form.disable();
        }
        else if (this.field.readonly && this.form && this.form.controls[this.field.key]) {
            this.form.controls[this.field.key].disable();
        }
        if (this.field.controlType === Constants.CONTROL_TYPE_DROPDOWN && this.field.listenToChange) {
            this.field.selected = "";
        }
    }

    ngOnDestroy() {
        if (this.field && this.field.options)
            this.field.options = null;
        if (this.dynamicdropdownOptions)
            this.dynamicdropdownOptions.unsubscribe();
    }

    onDropdownSelectionChange() {
        if (!this.field)
            return;
        if (this.field.listenToChange && this.field.selected) {
            let dropdownData: DropdownData = {
                key: this.field.key,
                value: this.field.selected,
                options: this.field.options
            };
            this.dropdownEvent.emit(dropdownData);
        }
    }

}

export interface DropdownData {
    key: string;
    value: string;
    options: string[]
}

